import React from 'react'
import { GetStaticPaths, GetStaticProps, NextPage } from 'next'
import { client } from '../../../apollo/client'
import { Layout } from '../../../components/layout/layout'
import { GlobalProps, withLayoutProps } from '../../../globals/layout'
import { nonNull } from '../../../utils/nonNull'
import { pageQuery } from '../../../utils/pageQuery'
import { REVALIDATION_FREQUENCY } from '../../../constants/revalidation'
import { FAQDetail } from '../../../templates/faqDetail'
import {
  FaqDetailPageQuery,
  FaqDetailPageQueryDocument,
  FaqDetailPageQueryVariables,
  FirstPageFaqsQuery,
  FirstPageFaqsQueryDocument,
  FirstPageFaqsQueryVariables,
  RetourQuery,
  RetourQueryDocument,
  RetourQueryVariables,
} from '@gql'

export type FAQDetailPageProps = GlobalProps & {
  data: FaqDetailPageQuery
}

const FAQDetailPage: NextPage<FAQDetailPageProps> = ({ data,  ...layoutProps }) => {
  return (
    <Layout { ...layoutProps }>
      <FAQDetail { ...data } />
    </Layout>
  )
}

export default FAQDetailPage

export const getStaticProps: GetStaticProps<Record<string, unknown>, { slug: string[] }> = async (context) => {
  const uri = `help-and-support/faqs/${context.params?.slug}`
  const { data } = await pageQuery<FaqDetailPageQuery, FaqDetailPageQueryVariables>({
    query: FaqDetailPageQueryDocument,
    variables: { uri },
  }, context)

  const retour = await client.query<RetourQuery, RetourQueryVariables>({
    query: RetourQueryDocument,
    variables: {
      uri: `/${uri}`,
    },
  })

  const { retourResolveRedirect } = retour?.data

  if (retourResolveRedirect?.redirectDestUrl !== null && typeof retourResolveRedirect?.redirectDestUrl === 'string') {
    return {
      redirect: {
        destination: retourResolveRedirect?.redirectDestUrl,
        permanent: false,
      },
    }
  }

  return withLayoutProps({
    path: `/${uri}`,
  }, data.entry ? {
    props: { data },
    revalidate: REVALIDATION_FREQUENCY,
  } : {
    notFound: true,
  })
}

export const getStaticPaths: GetStaticPaths = async () => {
  const { data } = await client.query<FirstPageFaqsQuery, FirstPageFaqsQueryVariables>({
    query: FirstPageFaqsQueryDocument,
  })

  return ({
    paths: nonNull(data.entries?.map(entry => entry?.slug ? `/help-and-support/faqs/${entry.slug}` : undefined) ?? []),
    fallback: 'blocking',
  })
}